export const FORMAT = {
  NUMERIC: 'numeric',
  TWO_DIGIT: '2-digit',
};

export const POSITION = {
  PRE: 'pre',
  POST: 'post',
};
